/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Blob_Save_Dialog_Select_DestinationInputs */



/**
* | output |
* | --- |
* | "Select a destination..." |
*
* @param {Chat_Blob_Save_Dialog_Select_DestinationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_save_dialog_select_destination = /** @type {((inputs?: Chat_Blob_Save_Dialog_Select_DestinationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_Save_Dialog_Select_DestinationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziel auswählen...")
	return /** @type {LocalizedString} */ ("Select a destination...")
});